import keywordApi from '@/api/keyword'

const state = () => ({
  all: [],
  keyword: {},
  grouped: null,
  deleted: null,
  allFromGroup: [],
  allToGroup: [],
  exportKeywords: null,
})

const getters = {}

const actions = {
  async getKeywords ({ commit }, params) {
    const result = await keywordApi.getAll(params)
    commit('setKeywords', result.data)
  },

  async getKeywordsFromGroup ({ commit }, params) {
    const result = await keywordApi.getAll(params)
    commit('setKeywordsFromGroup', result.data)
  },

  async getKeywordsToGroup ({ commit }, params) {
    const result = await keywordApi.getAll(params)
    commit('setKeywordsToGroup', result.data)
  },

  async getKeyword ({ commit }, id) {
    const result = await keywordApi.getOne(id)
    commit('setKeyword', result.data)
  },

  async create ({ commit }, data) {
    const result = await keywordApi.create(data)
    commit('setKeyword', result.data)
  },

  async update ({ commit }, { id, data }) {
    const result = await keywordApi.update(id, data)
    commit('setKeyword', result.data)
  },

  async delete ({ commit }, id) {
    const result = await keywordApi.deleteOne(id)
    commit('setDeleted', result.data)
  },

  async group ({ commit }, data) {
    const result = await keywordApi.group(data)
    commit('setGrouped', result.data)
  },

  async exportKeywords({ commit }, params){
    const result = await keywordApi.exportKeywords(params);
    commit('setExportKeywords', result.data);
  },
}

const mutations = {
  setKeyword (state, keyword) {
    state.keyword = keyword
  },
  setKeywords (state, keywords) {
    state.all = keywords
  },
  setKeywordsFromGroup (state, keywords) {
    state.allFromGroup = keywords
  },
  setKeywordsToGroup (state, keywords) {
    state.allToGroup = keywords
  },
  setGrouped (state, result) {
    state.grouped = result
  },
  setDeleted (state, result) {
    state.deleted = result
  },
  setExportKeywords(state, result) {
    state.exportKeywords = result;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}